<app-spinner [visible]="visibleSpinner"></app-spinner>

<app-mensajes [code]="code" [titulo]="titulo" [detalle]="detalle" [sw]="sw"></app-mensajes>
